import { BehaviourItem } from '../../../../../coaching-tags/models/behaviour.coaching.model';
import { SubBehaviourItem } from '../../../../../coaching-tags/models/subbehaviour.coaching.model';
import { BehaviourTag } from '../../../../transcript-dialog/model/behaviour-tag.model';

export function setFocus(
    behaviourId: number,
    subBehaviourId: number,
    behaviours?: BehaviourItem[],
    subBehaviours?: SubBehaviourItem[],
): BehaviourTag {
    const focus: BehaviourTag = {
        behaviour: behaviours?.find((e) => e.id === behaviourId),
        subBehaviour: subBehaviours?.find(
            (e) => e.id === subBehaviourId && e.behaviourId === behaviourId,
        ),
        isChecked: true,
    };
    return focus;
}
